<template>
  <div>
    <div class="home">

      <div class="comserver">

        <img src="../../assets/joinusimg/zkhz_banner_muchangjiankangguanli.png" width="100%" alt="">

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>引言</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">中科基因通过搭建智能化的检测服务共享平台，利用遍布全国的标准化实验室为用户提供定制化和一站式牧场健康管理服务，有效解决畜牧养殖业普遍存在的诊断结果不准确、治疗和保健效果不佳、抗生素耐药性问题严重、疫苗免疫不科学保护力不理想、动保产品非合理应用事故频发等造成的疫病防控成本高，疫情突发率高的问题。中科基因“牧场健康管理服务”是基于倡导先进科学管理理念，引导用户科学临床决策，确保牧场生产平稳运行，降低运营生产成本和保障畜禽健康安全。</div>
            </div>
          </div>
        </div>
        
        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>生物安全评估和健康体检服务</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">生物安全评估和健康体检是围绕牧场动物健康为中心的各种外部、内部环境及动物群体健康进行的监测检查，运用现场督察和实验室检测的手段，定期进行全面管理监测服务，协助用户了解牧场健康状态，及早发现健康危险因素，及时采取最佳处理方式，提高动物免疫和抗病能力，保障牧场健康生产。<span style="color:#F75F5F;font-size:14px">中科基因可为您提供牧场环境空气监测、水质监测、消毒效果监测、生物安全监测、动物群体健康评测</span>等项目内容服务，如您有需要请点击下方按钮联系我们。</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1 urlA"  @click="joinUs('0201')">联系我们</div>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>免疫效果评测服务</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">针对牧场为防控传染性疾病带来危害，进行免疫疫苗的免疫效果评测服务，利用科学准确、客观全面的实验室检测方法进行评测，通过定期的监测，了解牧场疫苗免疫保护水平，提前预警及早发现免疫漏洞，科学制定免疫程序，提高免疫精准度，降低免疫成本，为保障牧场健康生产奠定基础。<span style="color:#F75F5F;font-size:14px">中科基因可为您提供猪场、牛羊场、家禽场等牧场疫苗免疫效果评测服务，</span>如您有需要请点击下方按钮联系我们。</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1 urlA" @click="joinUs('0202')">联系我们</div>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>动物疫病诊断服务</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">疫病诊断服务是结合临床诊断和实验室检测方法，通过病理组织学、血清学、免疫学等实验室检验手段和中科名兽医APP服务平台，通过线上线下及时服务，精准诊疗，解决寻医难，诊断难等困扰。<span style="color:#F75F5F;font-size:14px">中科基因可为您提供猪腹泻疫病、猪呼吸系统疫病、猪繁殖障碍疫病、禽呼吸系统疫病、禽肠道系统疫病、牛腹泻疫病等疫病诊断检测服务，</span>如您有需要请点击下方按钮联系我们。</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1 urlA" @click="joinUs('0203')">联系我们</div>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>动物疫病净化服务</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">疫病净化服务指在特定区域或场所对某种或某些重点动物疫病实施的有计划的消灭过程中，通过对目标群的实验室检测和监测，辅助采取现场督察指导等措施，最终达到非免疫畜禽血清学和病原学监测阴性，免疫畜禽病原学监测阴性的净化标准。<span style="color:#F75F5F;font-size:14px">中科基因可为您提供猪伪狂犬病、禽白血病、鸡白痢、牛结核病、牛羊布病等疫病净化服务，</span>如您有需要请点击下方按钮联系我们。</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1" @click="joinUs('0204')">联系我们</div>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>兽用制品评测服务</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">产品评测服务是围绕牧场内所使用的相关兽用产品，参照国家相关质量标准和客户需求，通过实验室检测手段检测评估，为牧场选择使用安全、高效、质优价宜的产品提供参考依据。<span style="color:#F75F5F;font-size:14px">中科基因可为您提供兽药、疫苗、消毒剂、饲料等相关产品评测服务，</span>如您有需要请点击下方按钮联系我们。</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1" @click="joinUs('0205')">联系我们</div>
          </div>
        </div>

        <div class="box1 boxCompany" style="margin-bottom:0">
          <div class="title1"><img src="../../assets/joinusimg/zkhz_title_hezuohuoban.png" alt=""></div>
            
          <div class="infoCompany" @click="partner('1')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/chiyang.png" alt=""></dt>
              <dd>
                <div class="company">四川驰阳农业开发有限公司</div>
                <div class="infoWord">
                  <span>阳光</span>
                  <span>规范</span>
                  <span>共创</span>
                  <span>分享</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('2')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/dayushouyao.png" alt=""></dt>
              <dd>
                <div class="company">常州市大宇兽药有限公司</div>
                <div class="infoWord">
                  <span>兽药</span>
                  <span>疫苗</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('3')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/jinghaiqinye.png" alt=""></dt>
              <dd>
                <div class="company">江苏京海禽业集团有限公司</div>
                <div class="infoWord">
                  <span>京海</span>
                  <span>肉鸡</span>
                  <span>黄鸡</span>
                  <span>绿色</span>
                  <span>环保</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('4')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/kangmu.png" alt=""></dt>
              <dd>
                <div class="company">四川省康牧动保科技有限公司</div>
                <div class="infoWord">
                  <span>康牧</span>
                  <span>动保</span>
                  <span>畜牧</span>
                  <span>疫苗</span>
                  <span>兽药</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('5')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/kemu.png" alt=""></dt>
              <dd>
                <div class="company">四川柯牧生物科技有限公司</div>
                <div class="infoWord">
                  <span>勤奋</span>
                  <span>正直</span>
                  <span>感恩</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('6')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/beinong.png" alt=""></dt>
              <dd>
                <div class="company">山东大北农农牧科技有限责任公司</div>
                <div class="infoWord">
                  <span>养殖</span>
                  <span>饲料</span>
                  <span>兽药</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('7')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/zhengda.png" alt=""></dt>
              <dd>
                <div class="company">正大集团山东区</div>
                <div class="infoWord">
                  <span>生猪</span>
                  <span>养殖</span>
                  <span>食品</span>
                  <span>担保</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('8')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/daqing.png" alt=""></dt>
              <dd>
                <div class="company">黑龙江大庄园肉业有限公司</div>
                <div class="infoWord">
                  <span>农业产业化国家重点龙头企业</span>
                  <span> 两届中国牛羊肉协会会长单位</span>
                  <span>中国牛羊肉行业唯一肉类食品功勋企业</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('9')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/hahualong@3x.png" alt=""></dt>
              <dd>
                <div class="company">哈尔滨华隆蓝狐育种有限公司</div>
                <div class="infoWord">
                  <span>狐狸</span>
                  <span>对外贸易经营</span>
                  <span>貂的驯养繁殖</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('10')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/tianyuan.png" alt=""></dt>
              <dd>
                <div class="company">哈尔滨市天缘动物保健品经销处</div>
                <div class="infoWord">
                  <span>以诚信为本</span>
                  <span>以质量为先</span>
                  <span>以服务为宗旨</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('11')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/xiandai.png" alt=""></dt>
              <dd>
                <div class="company">现代牧业（集团）有限公司</div>
                <div class="infoWord">
                  <span>让您享受纯真鲜活的质感</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('12')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/huayang@3x.png" alt=""></dt>
              <dd>
                <div class="company">河南华扬农牧有限公司</div>
                <div class="infoWord">
                  <span>生猪</span>
                  <span>育种</span>
                  <span>养殖</span>
                  <span>销售</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('13')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/ruiminbo.png" alt=""></dt>
              <dd>
                <div class="company">湖南瑞民博环境工程有限公司</div>
                <div class="infoWord">
                  <span>畜禽养殖污水处理</span>
                  <span>环境</span>
                  <span>环保</span>
                  <span>水处理</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('14')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/minyi.png" alt=""></dt>
              <dd>
                <div class="company">福州闽益动保贸易有限公司</div>
                <div class="infoWord">
                  <span>服务</span>
                  <span>质量</span>
                  <span>诚信</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('15')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/minzheng.png" alt=""></dt>
              <dd>
                <div class="company">河南民正农牧股份有限公司</div>
                <div class="infoWord">
                  <span>生猪</span>
                  <span>养殖</span>
                  <span>销售</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="infoCompany" @click="partner('16')">
            <dl>
              <dt><img src="../../assets/joinusimg/companylogo/yongcheng.png" alt=""></dt>
              <dd>
                <div class="company">福建永诚农牧科技集团有限公司</div>
                <div class="infoWord">
                  <span>二十七年</span>
                  <span>永诚·长速快</span>
                  <span>永不止步</span>
                  <span>诚心服务</span>
                </div>
              </dd>
            </dl>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'muhealth',
  data(){
    return{
      userid: '',
      link: '',
      id: '',
      ua: window.navigator.userAgent.toLowerCase(),
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      }
    }
  },
  created(){
    this.userid = this.$route.query.user_id
  },
  methods: {
    openApp() {
      window.location = 'http://t.cn/Aijv8II4'
    },
    goShareExperts() {
      if (this.browser.android) {
        ZKAPP.ShareExperts();
      }else {
        window.webkit.messageHandlers.ShareExperts.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    tel(val) {
      if (this.browser.android) {
        this.link = 'tel:'+val
      }else {
        this.link = 'javascript:;'
        window.webkit.messageHandlers.jsToOcTelePhone.postMessage({tel:val});
      }
    },
    partner(val) {
      this.$router.push({
        name: 'partner-'+val,
      })
    },
    joinUs(val) {
      this.$router.push({
        name: 'Addjoin',
        query:{
          type: val,
          userid: this.userid
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.comserver{
  position: relative;
}
.box{
  background: #fff;
  padding-top: 25px;
  border-bottom: 15px solid rgba(245, 245, 245, 1);
  .title{
    display: flex;
    .shuTie{
      width: 4px;
      height: 22px;
      background: #004ea2;
      margin-left: 20px;
    }
    .titM {
      .titMax{
        color: #004ea2;
        font-size: 20px;
        font-weight: 600;
        line-height: 22px;
        margin-left: 10px;
        b {
          font-weight: bold;
        }
      }
    }
  }
  .info {
    padding: 15px 30px;
    .company {
      .company-title{
        padding: 5px 0;
        font-weight:600;
        color:rgba(51, 51, 51, 1);
        margin-bottom: 4px;
        font-size: 14px;
        text-align: center;
      }
      .company-text {
        line-height: 20px;
        font-size: 14px;
        color:rgba(51, 51, 51, 1);
        text-align: left;
      }
    }
  }
  .btnImg{
    width:100%;
    height: 60px;
    padding-bottom: 10px;
  }
}
.box1 {
  background: #fff;
  padding-top: 25px;
  margin-bottom: 15px;
  font-size: 0;
  .phone {
    text-align: center;
    .phoneInfo {
      display: flex;
      .shuTie {
        width: 4px;
        height: 22px;
        background: #004ea2;
        margin-left: 20px;
      }
      .phoneTit {
        color: #004ea2;
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-left: 10px;
        b {
          font-weight: bold;
        }
      }
    }
  }
  .btn {
    padding-bottom: 30px;
  }
}
.infoCompany {
  dl{
    width: 338px;
    background: #fff;
    margin: 15px auto;
    border-radius: 16px;
    display: flex;
    border:1px solid rgba(245, 245, 245, 1);
    color:rgba(51, 51, 51, 1);
    padding-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
    dt{
      margin: 12px;
      img{
        width: 48px;
        height: 48px;
      }
    }
    dd {
      .company{
        margin: 12px 0;
        text-align: left;
        font-size: 14px;
      }
      .infoWord{
        display: -webkit-flex;
        display:flex;
        -webkit-flex-wrap:wrap;
        flex-wrap:wrap;
        span{
          border:1px solid rgba(38, 60, 146, 1);
          padding: 0.5px 7px;
          background: #fff;
          color:rgba(38, 60, 146, 1);
          margin: 2px 2px;
          border-radius: 9px;
          font-size: 12px;
        }
      }
    }
  }
}

.btn1 {
  width: 184px;
  margin: 30px auto 0px;
  display: block;
  text-align: center;
  background: -webkit-linear-gradient(left, #0097e0 , #004ea2); /* Safari 5.1 - 6.0 */
  // background: -o-linear-gradient(left, #0097e0, #004ea2); /* Opera 11.1 - 12.0 */
  // background: -moz-linear-gradient(left, #0097e0, #004ea2); /* Firefox 3.6 - 15 */
  // background: linear-gradient(left,#0097e0, #004ea2);
  padding: 15px 0;
  border-radius: 50px;
  font-size: 14px;
  color:#fff;
}
</style>
